import { render, staticRenderFns } from "./ExtraDiscounts.vue?vue&type=template&id=c7dc5f1a&"
import script from "./ExtraDiscounts.vue?vue&type=script&lang=js&"
export * from "./ExtraDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExtraDiscounts.vue"
export default component.exports